<template>
  <v-container>
    <v-row class="text-center" v-show="loading">
      <v-progress-circular
        class="mx-auto loader"
        indeterminate
        color="orange"
        size="75"
      ></v-progress-circular>
    </v-row>

    <v-row align="center" v-show="!loading">
      <v-col cols="12" md="4" v-show="!embed">
        <SelectProfile v-if="!embed" @select="select"></SelectProfile>
      </v-col>
      <v-col cols="12" md="5" :class="{ 'text-center': !embed }">
        <span class="body-1">
          Showing {{ this.resources.length > 0 ? begin + 1 : 0 }} -
          {{ this.resources.length > 0 ? end + 1 : 0 }} of
          {{ resources.length }}
        </span>
        <v-btn text @click="prev">Prev</v-btn>
        <v-btn text @click="next">Next</v-btn>
      </v-col>
      <v-col right cols="12" :md="md" class="text-right">
        <v-btn class="mx-2" fab dark color="orange" @click="dialog = true">
          <v-icon dark>mdi-magnify</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="cards" v-show="!loading">
      <v-col cols="12" md="4" v-for="resource in filtered" :key="resource.id">
        <v-card height="320px">
          <v-card-title>{{ resource.name }}</v-card-title>
          <v-card-subtitle>
            {{ resource.address }} {{ resource.city }}, {{ resource.state }}
            {{ resource.zip }}
          </v-card-subtitle>
          <v-card-text>
            {{
              resource.description ? resource.description.substring(0, 200) : ""
            }}
            <span
              v-show="resource.description && resource.description.length > 200"
              >...</span
            >
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-show="resource.website"
              text
              color="blue darken-4"
              :href="`${resource.website}`"
              target="_blank"
            >
              <v-icon>mdi-earth</v-icon>
            </v-btn>
            <v-btn
              v-show="resource.email"
              text
              color="blue darken-4"
              :href="`mailto:+${resource.email}`"
              target="_parent"
            >
              <v-icon>mdi-email</v-icon>
            </v-btn>
            <v-btn
              v-show="resource.phone"
              text
              color="blue darken-4"
              :href="`tel:+${resource.phone}`"
              target="_parent"
            >
              <v-icon>mdi-phone</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-show="!embed"
              text
              color="red"
              class="action-btn"
              @click="remove(resource)"
              v-if="isSaved(resource)"
              >Remove</v-btn
            >
            <v-btn
              v-show="!embed"
              text
              class="action-btn"
              color="orange"
              @click="save(resource)"
              v-else
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card class="mb-3">
        <v-card-title>Search Resources</v-card-title>
        <v-card-subtitle>
          Find the right resource for you
        </v-card-subtitle>
        <v-card-text>
          <v-text-field
            v-model="filters.keyword"
            label="Keyword"
          ></v-text-field>
          <v-select
            v-model="filters.type"
            :items="types"
            item-text="name"
            label="Resource Type"
            return-object
          ></v-select>
          <v-select
            v-model="filters.stage"
            :items="stages"
            item-text="name"
            label="Life Stage"
            return-object
          ></v-select>
          <v-text-field v-model="filters.city" label="City"></v-text-field>
          <v-select
            v-model="filters.state"
            :items="states"
            label="State"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn block color="orange" dark @click="search">
            <v-progress-circular
              v-if="searching"
              indeterminate
              color="white"
            ></v-progress-circular>
            <span v-else>Search</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SelectProfile from "@/components/SelectProfile";

export default {
  name: "Resources",
  components: { SelectProfile },
  data() {
    return {
      begin: 0,
      dialog: false,
      embed: this.$router.currentRoute.name == "embed",
      end: 0,
      profile: null,
      filtered: [],
      filters: {
        city: null,
        keyword: null,
        stage: null,
        type: null,
        state: null
      },
      loading: true,
      md: this.$router.currentRoute.name == "embed" ? "7" : "3",
      searching: false
    };
  },
  computed: {
    ...mapGetters({
      resources: "resources/getResources",
      stages: "resources/getStages",
      states: "resources/getStates",
      types: "resources/getTypes"
    })
  },
  methods: {
    ...mapActions({
      findResources: "resources/findResources",
      initUser: "users/initUser",
      listResources: "resources/listResources",
      updateProfile: "profiles/updateProfile"
    }),
    initPagination() {
      this.begin = 0;
      this.end = 5;
      if (this.end >= this.resources.length) {
        this.end = this.resources.length - 1;
      }
    },
    isSaved(item) {
      let included = false;
      if (!this.profile || !this.profile.resources) {
        return included;
      }
      if (this.profile.resources.length < 1) {
        return included;
      }
      return this.profile.resources.includes(item.id);
    },
    next() {
      this.begin += 6;
      this.end += 6;
      if (this.end >= this.resources.length) {
        this.end = this.resources.length - 1;
      }
      if (this.begin >= this.resources.length) {
        this.begin = this.resources.length - 6;
        if (this.resources.length < 6) {
          this.begin = 0;
        }
      }
      this.setFiltered();
    },
    prev() {
      this.begin -= 6;
      this.end -= 6;
      if (this.begin < 0) {
        this.begin = 0;
      }
      if (this.end < 5) {
        this.end = 5;
        if (this.end >= this.resources.length) {
          this.end = this.resources.length - 1;
        }
      }
      this.setFiltered();
    },
    async remove(item) {
      const index = this.profile.resources.findIndex(i => i.id === item.id);
      this.profile.resources.splice(index, 1);
      await this.updateProfile({
        id: this.profile.id,
        resources: this.profile.resources
      });
    },
    async save(item) {
      let resources = this.profile.resources || [];
      resources.push(item.id);
      await this.updateProfile({
        id: this.profile.id,
        resources: resources
      });
    },
    async search() {
      this.searching = true;
      await this.findResources({
        city: this.filters.city ? this.toUpperCase(this.filters.city) : null,
        keyword: this.filters.keyword
          ? this.toUpperCase(this.filters.keyword)
          : null,
        stage: this.filters.stage,
        type: this.filters.type,
        state: this.filters.state
      });
      this.initPagination();
      this.setFiltered();
      this.filters = {
        city: null,
        keyword: null,
        stage: null,
        type: null,
        state: null
      };
      this.searching = false;
      this.dialog = false;
    },
    async select(profile) {
      if (this.embed) {
        return;
      }
      this.loading = true;
      this.profile = profile;
      await this.listResources(this.profile.id);
      this.initPagination();
      this.filtered = [];
      for (let i = this.begin; i <= this.end; i++) {
        this.filtered.push(this.resources[i]);
      }
      this.term = null;
      this.loading = false;
    },
    setFiltered() {
      this.filtered = [];
      for (let i = this.begin; i <= this.end; i++) {
        this.filtered.push(this.resources[i]);
      }
    },
    toUpperCase(text) {
      return text
        .toLowerCase()
        .split(" ")
        .map(s => s.charAt(0).toUpperCase() + s.substring(1))
        .join(" ");
    }
  },
  async mounted() {
    await this.initUser();
    await this.listResources();
    this.initPagination();
    this.setFiltered();
    this.loading = false;
  }
};
</script>

<style scoped>
.action-btn {
  position: absolute;
  left: 225px;
}
.cards .v-card__actions {
  position: absolute;
  bottom: 20px;
}
.loader {
  margin-top: 20%;
}
</style>
